import { Component, Prop, Vue } from 'vue-property-decorator';
import { CreateElement, VNodeData, VNode } from 'vue';

@Component
export default class ClPaper extends Vue {
  @Prop({
    type: Number,
    default: 0,
    validator: (x: number) => x >= 0 && x <= 24
  })
  public elevation!: number;

  @Prop({
    type: Boolean,
    default: false
  })
  public square!: boolean;

  /**
   * The component used for the root node.
   */
  @Prop({
    type: String,
    default: 'div'
  })
  public component!: string;

  render(h: CreateElement): VNode {
    const data: VNodeData = {
      class: {
        'cl-paper': true,
        'cl-paper--rounded': !this.square,
        [`cl-elevation--${this.elevation}`]: true
      }
    };
    return h(this.component, data, this.$slots.default);
  }
}
